import React from 'react';

export default function Synth() {
	// 18
	let style = {
		st29: {
			fill:"#5994C9"
		},
		st143: {
			fill:"#4A88BA"
		},
		st120: {
			fill:"#F2F2F2"
		},
		st0: {
			fill:"#FFFFFF"
		},
		st19: {
			fill:"#75C69F"
		},
		st1: {
			fill:"#A2D8C0"
		},
		st145: {
			fill:"#494949"
		},
		st24: {
			fill:"#FC5959"
		},
		st10: {
			fill:"#FC7E7E"
		}
	};
	return (
		<g>
			<path style={style.st29} d="M200.3323517,379.683136v40.2079773v0.0103149H20.3206825v-0.0103149V379.683136
				c0-2.9573975,2.3974209-5.3547974,5.3547897-5.3547974h13.9203415c1.3096237,0,2.3657799,1.0667114,2.3657799,2.3657837v0.1268616
				h136.7264862c0.0350342,0,0.0634308-0.0284119,0.0634308-0.063446l0,0c0-1.3360596,1.0931396-2.4291992,2.4292145-2.4291992
				h13.8074036C197.934845,374.3283386,200.3323517,376.7258301,200.3323517,379.683136z"/>
			<path style={style.st143} d="M185.0765991,410.6286011h-1.8436432H37.4200668h-7.5650883h-9.534296v13.4871521c0,0,0,0,0,0.0103149
				c0,1.3098755,0.5280781,2.5137939,1.3941994,3.3693237c0.8661213,0.8661194,2.0594559,1.404541,3.379652,1.404541h170.4639587
				c2.6403961,0,4.7738647-2.1437988,4.7738647-4.7738647c0-0.0103149,0-0.0103149,0-0.0103149v-13.4871521H185.0765991z"/>
			<path style={style.st120} d="M175.0097809,419.3462524H45.6399002c-2.0314713,0-3.6783066-1.6468201-3.6783066-3.6782837v-7.9827881
				h136.7264862v7.9827881C178.6880798,417.6994324,177.0412445,419.3462524,175.0097809,419.3462524z"/>
			<path style={style.st0} d="M178.6879883,400.0236816V376.694397c0-1.3050537-1.0578613-2.3629761-2.362793-2.3629761H44.3244629
				c-1.3049316,0-2.362793,1.0579224-2.362793,2.3629761v23.3292847l0,0v10.6049194h2.362793h14.8066406h4.7255859h14.8066406
				h4.7258301h14.8066406h4.7258301h14.8063965h4.7258301h14.8066406h4.7258301h14.8066406h4.7258301h14.8063965h2.362793V400.0236816
				L178.6879883,400.0236816z"/>
			<path style={style.st19} d="M34.0975266,400.2272644h-5.9127789c-0.9886894,0-1.7901821-0.8014832-1.7901821-1.7901917V380.633667
				c0-0.9887085,0.8014927-1.7901917,1.7901821-1.7901917h5.9127789c0.9886932,0,1.790184,0.8014832,1.790184,1.7901917v17.8034058
				C35.8877106,399.4257812,35.0862198,400.2272644,34.0975266,400.2272644z"/>
			<path style={style.st1} d="M31.9852123,390.4361877h-1.6881485c-0.9886913,0-1.790184-0.8014832-1.790184-1.7901917v-5.9000244
				c0-0.988678,0.8014927-1.7901917,1.790184-1.7901917h1.6881485c0.9886913,0,1.7901859,0.8015137,1.7901859,1.7901917v5.9000244
				C33.7753983,389.6347046,32.9739037,390.4361877,31.9852123,390.4361877z"/>
			<rect x="60.4375" y="395.4804688" style={style.st120} width="2.1132812" height="18.1582031"/>
			<rect x="79.9697266" y="395.4804688" style={style.st120} width="2.1132812" height="18.1582031"/>
			<rect x="99.5019531" y="374.331543" style={style.st120} width="2.1132812" height="39.3071289"/>
			<rect x="119.0341797" y="395.4804688" style={style.st120} width="2.1132812" height="18.1582031"/>
			<rect x="138.5664062" y="395.4804688" style={style.st120} width="2.1132812" height="18.1582031"/>
			<rect x="158.0996094" y="395.4804688" style={style.st120} width="2.1132812" height="18.1582031"/>
			<path style={style.st145} d="M65.0377502,395.4806824h-7.0875816c-1.2509651,0-2.2650719-1.0140991-2.2650719-2.2650757v-18.8872681
				c0-1.2509766,2.0702629-4.8869019,3.321228-4.8869019h4.9752693c1.2509651,0,3.3212318,3.6359253,3.3212318,4.8869019v18.8872681
				C67.3028259,394.4665833,66.2887192,395.4806824,65.0377502,395.4806824z"/>
			<path style={style.st145} d="M84.5701599,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681
				c0-1.2509766,2.0702667-4.8869019,3.3212357-4.8869019h4.9752655c1.2509689,0,3.3212357,3.6359253,3.3212357,4.8869019v18.8872681
				C86.8352356,394.4665833,85.8211212,395.4806824,84.5701599,395.4806824z"/>
			<path style={style.st145} d="M123.6348495,395.4806824h-7.0875854c-1.2509613,0-2.2650681-1.0140991-2.2650681-2.2650757v-18.8872681
				c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752731c1.2509613,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681
				C125.8999252,394.4665833,124.8858185,395.4806824,123.6348495,395.4806824z"/>
			<path style={style.st145} d="M143.1672211,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681
				c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752655c1.2509766,0,3.3212433,3.6359253,3.3212433,4.8869019v18.8872681
				C145.4322968,394.4665833,144.4181824,395.4806824,143.1672211,395.4806824z"/>
			<path style={style.st145} d="M162.699585,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681
				c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752808c1.2509613,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681
				C164.9646606,394.4665833,163.9505463,395.4806824,162.699585,395.4806824z"/>
			<path style={style.st24} d="M189.5102234,388.3366394h-0.0000153c-2.610611,0-4.7465668-2.1359558-4.7465668-4.746582l0,0
				c0-2.6106262,2.1359558-4.746582,4.7465668-4.746582h0.0000153c2.610611,0,4.7465668,2.1359558,4.7465668,4.746582l0,0
				C194.2567902,386.2006836,192.1208344,388.3366394,189.5102234,388.3366394z"/>
			<path style={style.st24} d="M189.5102234,400.2272644h-0.0000153c-2.610611,0-4.7465668-2.1359558-4.7465668-4.7465515v-0.0000305
				c0-2.6105957,2.1359558-4.7465515,4.7465668-4.7465515h0.0000153c2.610611,0,4.7465668,2.1359558,4.7465668,4.7465515v0.0000305
				C194.2567902,398.0913086,192.1208344,400.2272644,189.5102234,400.2272644z"/>
			<path style={style.st10} d="M189.5102081,386.2243042L189.5102081,386.2243042c-1.4488373,0-2.6342468-1.1854248-2.6342468-2.6342468
				l0,0c0-1.4488525,1.1854095-2.6342773,2.6342468-2.6342773l0,0c1.4488525,0,2.6342621,1.1854248,2.6342621,2.6342773l0,0
				C192.1444702,385.0388794,190.9590607,386.2243042,189.5102081,386.2243042z"/>
			<path style={style.st10} d="M189.5102081,398.1149597L189.5102081,398.1149597c-1.4488373,0-2.6342468-1.1854248-2.6342468-2.6342773
				l0,0c0-1.448822,1.1854095-2.6342468,2.6342468-2.6342468l0,0c1.4488525,0,2.6342621,1.1854248,2.6342621,2.6342468l0,0
				C192.1444702,396.9295349,190.9590607,398.1149597,189.5102081,398.1149597z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Synth.js